import React from 'react'
import styled from 'styled-components'
import { Label } from '../../shared/simple/Label'
import { OptionItem } from '../../shared/simple/OptionItem'
import { useTextLanguage } from '../../../hooks/useShared'
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { fieldUniqueName, isUndefinedNull, notUndefinedNull } from '../../../helpers/shared'
import { theme } from '../../../theme/theme'
import { useWatch } from 'react-hook-form'
import { hiddenField } from '../../../constants/form'
const { first } = theme;

const StyledGroup = styled(Form.Group)`
  margin-bottom: 20px;
  position: relative;
  bottom: 4px;
`;

const StyledSelect = styled(Form.Select)`
  width: ${({width}) => `${width}px` || 'auto'};
  &:focus {
    border-color: ${first};
    box-shadow: none;
  }
`;

/**
 * Description placeholder
 *
 * @param {String} type - Specify the desired 'Selector' (either 'ordinal' or 'weekday')
 * @returns {*}
 */
const InternalSelector = ({ 
  options, width, text, setOrdinal, setValue, uniqueName, parentCheckName, checkNumber, selectorName, containerSelectorValues, validationOrder,
  type
 }) => {
  return (
    <>
      <InternalSelect 
        options={options}
        width={width}
        text={text}
        setOrdinal={setOrdinal}
        setValue={setValue}
        parentCheckName={parentCheckName}
        uniqueName={uniqueName}
        checkNumber={checkNumber}
        selectorName={selectorName}
        containerSelectorValues={containerSelectorValues}
        validationOrder={validationOrder}
        type={type}
      />
    </>
  )
}


const InternalSelect = ({ options, width, text, setValue, uniqueName, parentCheckName, checkNumber, selectorName, containerSelectorValues, validationOrder, type }) => {
  const { languageText } = useTextLanguage();
  const { t } = useTranslation();
  const [isParentChecked, setIsParentChecked] = React.useState(false)
  let value = useWatch({name: uniqueName || ''}) 


  const handleChange = async (e) => {
    let eventValue = e?.target?.value
    let element = fieldUniqueName(parentCheckName)
    let finalValue =  setValue(uniqueName, eventValue, checkNumber)
    element.value = finalValue
    element.click()
  }

  // Enabling/Disabling selector's in the current checkbox
  React.useEffect(() => {
    let element = fieldUniqueName(parentCheckName)
    let isChecked = element?.checked
    setIsParentChecked(isChecked)    
  }, [parentCheckName, value])

  const prevSelectorValues = containerSelectorValues?.[validationOrder-1]?.value
  const firstSelectorValue = containerSelectorValues?.[0]?.value

  // * New calculation for the enabled variable
  const enabled = isParentChecked &&
    (validationOrder == 0) ||
    ((validationOrder > 0) && notUndefinedNull(prevSelectorValues) && notUndefinedNull(firstSelectorValue) && prevSelectorValues !== hiddenField && firstSelectorValue !== hiddenField) ||
    isUndefinedNull(containerSelectorValues)
  
  // * Defining an optionsDelimitator
  let delimitator
  const simpleSelectorOptionLength = 2   // ? Simple option has 2 Internal Selectors
  const compoundSelectorOptionLength = 4 // ? Compound option has 4

  // ? Suffices for the simple option
  if (containerSelectorValues?.length == simpleSelectorOptionLength && validationOrder == 1) delimitator = prevSelectorValues

  // ? The compounded would have to be different
  if (containerSelectorValues?.length == compoundSelectorOptionLength && validationOrder == 2 && firstSelectorValue !== hiddenField) { delimitator = firstSelectorValue  }

  return(
    <StyledGroup className="">
        <Label htmlFor={ 'uniqueName' }>
          
        </Label>
        <StyledSelect
          width={width}
          className='resettable-select'
          onChange={ handleChange }
          disabled={!enabled}
          id={selectorName}
          defaultValue={ 'defaultValue' }
          data-type={type}
          data-validation-order={validationOrder}
        >
          <option
            className="d-none"
            id={ hiddenField }
            value={ hiddenField }
          >
          </option>
          <OptionItem
            languageText={ languageText }
            options={ options }
            type="simple"
            text={text}
            delimitator={delimitator}
          />
        </StyledSelect>
    </StyledGroup>
  )

}

export default InternalSelector